export default __webpack_public_path__ + "cd2aa908ba117b8993706a15d7bc37f0.svg";